import { useEffect } from 'react';

/**
 * Ставит favicon на основе типа REST сервера из конфига.
 * IndorPower -> favicon_indor_power.svg, иначе -> favicon_indor_road.svg
 */
export function useTitle(restServerType?: string | null) {
    useEffect(() => {
        const titleText =
            restServerType === 'IndorPower'
                ? "IndorPower Geoportal: Геопортал электрических сетей"
                : "IndorRoad Geoportal: Геопортал автомобильных дорог";

        document.title = titleText;
    }, [restServerType]);
}